export { default } from "./ChangeNumberValue";
